import React, { useState, useEffect } from 'react';
import { get, post, put } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Suppliers() {
  const { hasPermission } = useAuth();
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [search, setSearch] = useState('');

  const load = () => {
    setLoading(true);
    get('/suppliers').then(d => setSuppliers(d.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);
  const filtered = suppliers.filter(s =>
    !search || s.name.toLowerCase().includes(search.toLowerCase()) ||
    (s.phone||'').includes(search) || (s.email||'').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="flex-between mb-lg">
        <h2 className="page-title">Suppliers</h2>
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          <input className="form-control" placeholder="Search by name, phone or email..."
            value={search} onChange={e=>setSearch(e.target.value)}
            style={{width:260,fontSize:13}} />
          {hasPermission('suppliers:write') && (
            <button className="btn btn-primary" onClick={() => setModal({})}>+ Add Supplier</button>
          )}
        </div>
      </div>
      <div className="tbl-wrap">
        {loading ? <div className="spinner"></div> : (
          <table>
            <thead><tr><th>Name</th><th>Category</th><th>Phone</th><th>Bank</th><th>Account No</th><th></th></tr></thead>
            <tbody>
              {filtered.length === 0
                ? <tr><td colSpan="6"><div className="empty-state"><h3>No suppliers yet</h3></div></td></tr>
                : filtered.map(s => (
                  <tr key={s.id}>
                    <td style={{fontWeight:500}}>{s.name}</td>
                    <td><span className="badge b-grey">{s.category||'—'}</span></td>
                    <td>{s.phone||'—'}</td>
                    <td className="text-muted text-sm">{s.bank_name||'—'}</td>
                    <td className="text-muted text-sm">{s.bank_account_no||'—'}</td>
                    <td>{hasPermission('suppliers:write') &&
                      <button className="btn btn-ghost btn-sm" onClick={() => setModal(s)}>Edit</button>}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )}
      </div>
      {modal !== null && (
        <SupplierModal supplier={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />
      )}
    </div>
  );
}

function SupplierModal({ supplier, onClose, onSaved }) {
  const isEdit = supplier?.id;
  const [form, setForm] = useState(supplier || { name:'',phone:'',email:'',address:'',category:'raw_materials',notes:'',bank_name:'',bank_account_no:'',bank_account_name:'' });
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!form.name) { alert('Supplier name is required'); return; }
    // Duplicate check by phone
    if (!isEdit && form.phone) {
      const existing = await get('/suppliers').then(d=>(d.data||[]).find(s=>s.phone===form.phone)).catch(()=>null);
      if (existing) {
        if (!window.confirm('A supplier with phone '+form.phone+' already exists: "'+existing.name+'". Add anyway?')) return;
      }
    }
    setSaving(true);
    try {
      if (isEdit) await put('/suppliers/'+supplier.id, form);
      else await post('/suppliers', form);
      onSaved();
    } finally { setSaving(false); }
  };
  return (
    <div className="modal-overlay"><div className="modal">
      <div className="modal-hdr">
        <span className="modal-title">{isEdit?'Edit':'New'} Supplier</span>
        <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
      </div>
      <div className="modal-body">
        <div className="form-row">
          <div className="form-group"><label className="form-label">Name *</label>
            <input className="form-control" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Category</label>
            <select className="form-control" value={form.category} onChange={e=>setForm({...form,category:e.target.value})}>
              <option value="raw_materials">Raw Materials</option>
              <option value="printing">Printing</option>
              <option value="logistics">Logistics</option>
              <option value="artisan">Artisan</option>
              <option value="other">Other</option>
            </select></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Phone</label>
            <input className="form-control" value={form.phone||''} onChange={e=>setForm({...form,phone:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Email</label>
            <input className="form-control" value={form.email||''} onChange={e=>setForm({...form,email:e.target.value})} /></div>
        </div>
        <div className="form-group"><label className="form-label">Notes</label>
          <textarea className="form-control" rows={2} value={form.notes||''} onChange={e=>setForm({...form,notes:e.target.value})} /></div>
        <div className="divider"></div>
        <div style={{fontSize:10,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',color:'var(--ink-light)',marginBottom:12}}>Bank / Payment Details</div>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Bank Name</label>
            <input className="form-control" placeholder="e.g. GTBank, Moniepoint" value={form.bank_name||''} onChange={e=>setForm({...form,bank_name:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Account Number</label>
            <input className="form-control" value={form.bank_account_no||''} onChange={e=>setForm({...form,bank_account_no:e.target.value})} /></div>
        </div>
        <div className="form-group"><label className="form-label">Account Name</label>
          <input className="form-control" value={form.bank_account_name||''} onChange={e=>setForm({...form,bank_account_name:e.target.value})} /></div>
      </div>
      <div className="modal-ftr">
        <button className="btn btn-outline" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>{saving?'Saving...':'Save'}</button>
      </div>
    </div></div>
  );
}
